module.exports = __webpack_public_path__ + "img/onboarding_gift.712692fc.png";